import { cn, platformProps } from "../../lib";
import { Box } from "../../primitives";
import type { AccountMenuPanelHeaderProps } from "./types";

/**
 * Header slot of AccountMenuPanel.
 * Typical content: avatar+name (logged in) or auth CTAs (logged out).
 */
export const AccountMenuPanelHeader = ({
  children,
  className,
  testID,
}: AccountMenuPanelHeaderProps) => (
  <Box
    {...platformProps({ testID, slot: "account-menu-panel-header" })}
    as="header"
    className={cn(
      "px-spacing-lg py-spacing-md border-luce-neutral-border-mediumEmphasis border-b",
      className,
    )}
  >
    {children}
  </Box>
);

AccountMenuPanelHeader.displayName = "AccountMenuPanel.Header";
